import { useState, useEffect } from "react";

// AuthCallback Component - Use this for /auth/callback route
function AuthCallback() {
  useEffect(() => {
    // Handle both regular URLs and hash-based URLs (React Router hash mode)
    let urlParams;

    // Check if params are in hash (after #)
    if (window.location.hash.includes("?")) {
      const hashQuery = window.location.hash.split("?")[1];
      urlParams = new URLSearchParams(hashQuery);
    } else {
      // Regular query params
      urlParams = new URLSearchParams(window.location.search);
    }

    const authToken = urlParams.get("auth_token");
    const feedToken = urlParams.get("feed_token");
    const refreshToken = urlParams.get("refresh_token");


    if (authToken && feedToken && refreshToken) {
      // Store tokens in localStorage
      localStorage.setItem("smartapi_auth_token", authToken);
      localStorage.setItem("smartapi_feed_token", feedToken);
      localStorage.setItem("smartapi_refresh_token", refreshToken);


      // Send tokens to parent window if this is opened in a popup
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(
          {
            type: "SMARTAPI_AUTH_SUCCESS",
            authToken,
            feedToken,
            refreshToken,
          },
          "*"
        );

        // Close popup after a short delay
        setTimeout(() => {
          window.close();
        }, 500);
      } else {
        // If not in popup, redirect to home page
        setTimeout(() => {
          window.location.href = "/#home"; // Change to '/#/' for hash router
        }, 1000);
      }
    } else {
      console.error("❌ Missing tokens in callback URL");
      // Redirect to home even if there's an error
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
    }
  }, []);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        fontFamily: "sans-serif",
        background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%)",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <div
          style={{
            width: "48px",
            height: "48px",
            border: "4px solid #e5e7eb",
            borderTopColor: "#9333ea",
            borderRadius: "50%",
            margin: "0 auto 16px",
            animation: "spin 1s linear infinite",
          }}
        ></div>
        <p style={{ color: "#6b7280", fontWeight: "500", margin: "0 0 8px 0" }}>
          Processing authentication...
        </p>
        <p style={{ color: "var(--text-muted)", fontSize: "12px", margin: 0 }}>
          Redirecting to home page...
        </p>
      </div>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

// Main Login Component
export default function SmartAPILogin() {
  const [status, setStatus] = useState("Click to login");
  const [tokens, setTokens] = useState(null);

  const apiKey = "VbBjrdQN";
  const stateVariable = "statevariable";
  const redirectUrl = "https://inrise.in/auth/callback";
  const smartApiUrl = `https://smartapi.angelone.in/publisher-login?api_key=${apiKey}&state=${stateVariable}`;

  useEffect(() => {
    const storedAuthToken = localStorage.getItem("smartapi_auth_token");
    const storedFeedToken = localStorage.getItem("smartapi_feed_token");
    const storedRefreshToken = localStorage.getItem("smartapi_refresh_token");

    if (storedAuthToken && storedFeedToken && storedRefreshToken) {
      setTokens({
        authToken: storedAuthToken,
        feedToken: storedFeedToken,
        refreshToken: storedRefreshToken,
      });
      setStatus("Already authenticated");
    }

    const handleMessage = (event) => {
      if (event.data.type === "SMARTAPI_AUTH_SUCCESS") {
        setTokens({
          authToken: event.data.authToken,
          feedToken: event.data.feedToken,
          refreshToken: event.data.refreshToken,
        });
        setStatus("Authentication successful!");
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const handleLogin = () => {
    setStatus("Opening login window...");
    setTokens(null);

    const popup = window.open(
      smartApiUrl,
      "SmartAPI Login",
      "width=600,height=700,scrollbars=yes"
    );

    if (!popup || popup.closed || typeof popup.closed == "undefined") {
      setStatus("Popup was blocked. Please allow popups for this site.");
      return;
    }

    const checkPopup = setInterval(() => {
      if (popup.closed) {
        clearInterval(checkPopup);
        if (!tokens) {
          setStatus("Login window closed");
        }
      }
    }, 500);
  };

  const handleLogout = () => {
    localStorage.removeItem("smartapi_auth_token");
    localStorage.removeItem("smartapi_feed_token");
    localStorage.removeItem("smartapi_refresh_token");
    setTokens(null);
    setStatus("Logged out successfully");
  };

  const styles = {
    container: {
      minHeight: "100vh",
      background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "24px",
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
    },
    wrapper: {
      width: "100%",
      maxWidth: "700px",
    },
    card: {
      background: "white",
      borderRadius: "16px",
      boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
      border: "1px solid #e2e8f0",
      overflow: "hidden",
    },
    header: {
      background: "linear-gradient(135deg, #9333ea 0%, #6366f1 100%)",
      padding: "32px",
      color: "white",
    },
    title: {
      fontSize: "28px",
      fontWeight: "bold",
      marginBottom: "8px",
      margin: 0,
    },
    subtitle: {
      color: "rgba(255, 255, 255, 0.9)",
      fontSize: "14px",
      margin: 0,
    },
    content: {
      padding: "32px",
    },
    button: {
      width: "100%",
      padding: "16px 24px",
      background: "linear-gradient(135deg, #9333ea 0%, #6366f1 100%)",
      color: "white",
      border: "none",
      borderRadius: "12px",
      fontSize: "18px",
      fontWeight: "600",
      cursor: "pointer",
    },
  };

  return (
    <div style={styles.container}>
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
      <div style={styles.wrapper}>
        <div style={styles.card}>
          <div style={styles.header}>
            <h1 style={styles.title}>SmartAPI Authentication</h1>
            <p style={styles.subtitle}>
              Securely connect your Angel One account
            </p>
          </div>
          <div style={styles.content}>
            <button style={styles.button} onClick={handleLogin}>
              Login with SmartAPI
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export { AuthCallback };
